export const brandsBoxStyle = { marginBottom: '$8' }
export const brandsTitleStyle = {
  fontSize: '$body-medium',
  color: '$dark-light',
  marginBottom: '$4'
}
export const brandsAsteriskStyle = { color: '$error-standard', marginLeft: '$1' }
